export enum ButtonSize {
	Small = 'small',
	Large = 'large',
	Huge = 'huge',
}